import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToasterModule } from 'angular2-toaster';

@NgModule({
  imports: [CommonModule, ToasterModule.forChild()],
  exports: [ToasterModule]
})
export class SharedUtilsNotificationsModule {}
